exports.components = {
  "component---src-pages-coscreen-name-invite-code-tsx": () => import("./../../../src/pages/[coscreenName]/[inviteCode].tsx" /* webpackChunkName: "component---src-pages-coscreen-name-invite-code-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

